// - **Purpose**: The component is designed to display a `StoreFinder` UI by extracting store data from the passed `StoreData` object.
// - **Data Access**: It retrieves store data using destructuring from `data` passed as a prop, specifically targeting `channel.body.results` in the `StoreData` object.
// - **Conditional Rendering**: The component checks if `storeData` exists before rendering the `StoreFinder` component. If no store data is available, it returns an empty fragment (`<></>`), effectively rendering nothing.
// - **Child Component**: It passes the `storeData` to the `StoreFinder` component as a prop, which likely uses it to display a list of stores or locations.
// - **TypeScript Usage**: The `data` prop is typed as `StoreData`, ensuring type safety for the incoming store data.

'use client';

import StoreFInder from 'components/commercetools-ui/organisms/StoreFinder';
import React from 'react';

const FindStoreTastic = ({ data }: any) => {
  const storeData = data?.data?.dataSource?.channel?.body?.results;
  if (!storeData) {
    return <></>;
  }

  return (
    <div>
      <StoreFInder storeData={storeData} />
    </div>
  );
};

export default FindStoreTastic;
